import type { User } from '../../api/types'
import { db, type LocalChannel } from '../../db/db'

/** Who a one-to-one conversation is with: the bot of a bot conversation, the other person of a direct message. */
function peerOf(channel: LocalChannel, meId: string): string | undefined {
  if (channel.type === 'bot_dm') return channel.bot?.userId ?? channel.memberIds.find((id) => id !== meId)
  return channel.memberIds.find((id) => id !== meId)
}

const lastActive = (channel: LocalChannel) => channel.lastMessage?.createdAt ?? channel.createdAt

/** The people and bots this phone has one-to-one conversations with, the most recently active first. */
export async function recentContacts(meId: string, limit = 5): Promise<User[]> {
  const channels = await db.channels.where('type').anyOf('dm', 'bot_dm').toArray()
  const ordered = channels.filter((c) => !c.archivedAt).sort((a, b) => lastActive(b).localeCompare(lastActive(a)))
  const people: User[] = []
  for (const channel of ordered) {
    const peer = peerOf(channel, meId)
    if (!peer || people.some((p) => p.id === peer)) continue
    const user = await db.users.get(peer)
    if (user) people.push(user)
    if (people.length === limit) break
  }
  return people
}

/** The conversation this phone already has with someone, if there is one. */
export async function existingConversationWith(meId: string, userId: string): Promise<string | undefined> {
  const channels = await db.channels.where('type').anyOf('dm', 'bot_dm').toArray()
  return channels.find((c) => peerOf(c, meId) === userId)?.id
}
